import cn from 'classnames';
import React from 'react';

import AemEditableText from '@/components/Aem/AemEditableText/AemEditableText';
import BackButton from '@/components/BackButton/BackButton';
import {StickyHeader} from '@/components/Layout';
import {SELECT_YOUR_DEVICE_PAGE_HEADER_TITLE} from '@/consts/localization/localizationKeys';
import routePaths from '@/consts/route/routePaths';
import useLayout from '@/hooks/layout/useLayout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import {getLocalizedStrings} from '@/services/localization/localizationService';
import {WARNING_BANNER_SOURCE_TYPES, WarningBanners, WarningBannersTop} from '@/views/WarningBanners';

import SelectDeviceItem from './SelectDeviceItem';

const SelectYourDeviceContent = ({supportedDeviceData, onBack}) => {
    const {isMobile, isDesktop} = useLayout();
    const localizedStrings = getLocalizedStrings();

    useDocumentTitle(localizedStrings[SELECT_YOUR_DEVICE_PAGE_HEADER_TITLE]);

    return (
        <div className='flex flex-1 flex-col bg-primary-dark-5 pt-0-hw-offset ml:pt-0'>
            <WarningBannersTop
                source={WARNING_BANNER_SOURCE_TYPES.SELECT_DEVICE}
                className='ml:pl-[var(--sidebar-width)]'
            />
            <div className='pt-safe-offset-sticky-header mx-4 pb-8 ml:mx-16'>
                <div>
                    {isDesktop && <BackButton className='mb-4 mt-8' onBack={onBack} />}
                    {isMobile && (
                        <StickyHeader
                            internalClassName='md:px-3'
                            onBack={onBack}
                            title={localizedStrings[SELECT_YOUR_DEVICE_PAGE_HEADER_TITLE]}
                        />
                    )}
                    <h1 className='m-0 text-left text-32 ml:text-36'>
                        <AemEditableText pageName={routePaths.DEVICES_PAGE} itemName='SelectYourDeviceTitle' />
                    </h1>
                </div>
                <ul className={cn('mt-8 grid w-full grid-cols-1 gap-2 ml:mt-10 ml:grid-cols-3 ml:gap-4')}>
                    {supportedDeviceData.map(({type, name, images}, i) => {
                        return (
                            <SelectDeviceItem
                                alt={name}
                                image={images}
                                key={type}
                                name={name}
                                type={type}
                                isLast={i === supportedDeviceData.length - 1}
                            />
                        );
                    })}
                </ul>
            </div>
            <WarningBanners className='-mt-4' source={WARNING_BANNER_SOURCE_TYPES.SELECT_DEVICE} />
        </div>
    );
};

export default SelectYourDeviceContent;
